export * from "./queries";
export * from "./sanity";

export { groq } from "next-sanity";
